import { z } from 'zod'
import {
  ValueObject,
  ResultOrError,
} from '@lukso/controllerapps-sharedlogic-ddd-core'

import { BackupReportParseError } from '../errors/BackupReportParseError'

export const EncryptedBackupSchema = z.object({
  data: z.string(),
  iv: z.string(),
  salt: z.string(),
})

export const EncryptedBackupPropsSchema = z.object({
  data: z.string(),
  iv: z.string(),
  salt: z.string(),
})

export type EncryptedBackupProps = z.infer<typeof EncryptedBackupPropsSchema>

export class EncryptedBackup extends ValueObject<EncryptedBackupProps> {
  public get data(): string {
    return this.props.data
  }

  public get iv(): string {
    return this.props.iv
  }

  public get salt(): string {
    return this.props.salt
  }

  public toString(): string {
    return JSON.stringify(this.props)
  }

  public getReportText(): string {
    const { data, iv, salt } = this.props
    return JSON.stringify({
      data,
      iv,
      salt,
    })
  }

  public static createFromReportText(
    reportText: string
  ): ResultOrError<EncryptedBackup, BackupReportParseError> {
    let reportTextObject: string
    try {
      reportTextObject = JSON.parse(reportText)
    } catch (error) {
      return ResultOrError.error(
        new BackupReportParseError(`Invalid JSON in EncryptedBackup: ${error}`)
      )
    }
    const validatedReport = EncryptedBackupSchema.parse(reportTextObject)
    const { data, iv, salt } = validatedReport

    const report = EncryptedBackup.create({
      data,
      iv,
      salt,
    })
    return ResultOrError.success(report)
  }

  public static create(props: EncryptedBackupProps): EncryptedBackup {
    const validatedProps = EncryptedBackupPropsSchema.parse(props)
    return new EncryptedBackup(validatedProps)
  }
}
